import { ConstantService } from 'app/Shared/Services/constant-service';
import { FinraExceptionService } from './finra-exception.service';
import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { LazyLoadEvent, ConfirmationService,MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { FinraException } from './finra-exception.model';
import { UserService } from 'app/Shared/Services/user.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { ActivatedRoute, Router } from '@angular/router';
import {default as listCols} from './main-list.json';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { FieldDictionary } from './field-dictionary.model';
import { HttpErrorResponse } from '@angular/common/http';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { EventTreeService } from 'app/Shared/Component/event-tree/event-tree.service';
import { DataService } from 'app/Shared/Services/data.service';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { Table, TableModule } from 'primeng/table';
import { LowerCasePipe, NgClass, CommonModule, NgStyle } from '@angular/common';
import { SymbolPanelComponent } from 'app/Shared/Component/symbol-panel/symbol-panel.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ButtonModule } from 'primeng/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { NewROEEntryComponent } from 'app/Shared/Component/new-roe-entry/new-roe-entry.component';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { MassCorrectionComponent } from 'app/Shared/Component/mass-correction/mass-correction.component';
import { FinraExceptionViewComponent } from './finra-exception-view/finra-exception-view.component';
import { FinraExceptionEditComponent } from './finra-exception-edit/finra-exception-edit.component';
import { CounterpartyPartyReportComponent } from './counterparty-report/counterparty-report.component';
import { EventTreeDialogComponent } from 'app/Shared/Component/event-tree/event-tree-dialog.componenet';
import { AuditTrailDialogComponent } from 'app/Shared/Component/audit-trail/audit-trail-dialog.componenet';
import { ExceptionCommentComponent } from 'app/Shared/Component/exception-comment/exception-comment.component';
import { MultiLegEventComponent } from '../cat-roe-viewer/multileg-event/multileg-event.component';
import { CreateParentComponent } from './create-parent/create-parent.component';
import { SingleEditFormComponent } from 'app/Shared/Component/single-edit-form/single-edit-form.component';
import { TooltipModule } from 'primeng/tooltip';
import { FinraExceptionSummaryComponent } from './finra-exception-summary/finra-exception-summary.component';
import { QuickSearchComponent } from "app/Shared/Component/quick-search/quick-search.component";
import { ViewFdidComponent } from 'app/Pages/ref-data-viewer/fdid-info/view-fdid/view-fdid.component';
import { Select } from 'primeng/select';
import { TabsModule } from 'primeng/tabs';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu';
import { GridCommonService } from 'app/Shared/Services/grid-common.service';

@Component({
    selector: 'app-finra-exception-main',
    imports: [ToastModule, ConfirmDialogModule, FilterPanelComponent, TableModule, TabsModule, CommonModule, SymbolPanelComponent, MatProgressSpinner,
        ButtonModule, MatTooltipModule, NewROEEntryComponent, LowerCasePipe, FormsModule, Select, ExportToCSVSComponent, NgStyle, MassCorrectionComponent,
        FinraExceptionViewComponent, FinraExceptionEditComponent, CounterpartyPartyReportComponent, EventTreeDialogComponent,
        AuditTrailDialogComponent, ExceptionCommentComponent, MultiLegEventComponent, ViewFdidComponent,ContextMenuModule,
        CreateParentComponent, SingleEditFormComponent, NgClass, TooltipModule, FinraExceptionSummaryComponent, QuickSearchComponent
    ],
    templateUrl: 'finra-exception-main.component.html',
    styleUrls: ['./finra-exception-main.component.scss']
})
export class FinraExceptionMainComponent implements OnInit {
  @ViewChild(('dt')) dt!: Table;
  @ViewChild('cm') contextMenuItems!: ContextMenu;
  quickFilterArray: any;
  filterFieldDefaultValues: any = new Object();
  selectedTabIndex: any = 0;
  cols: any;
  ApplicationName: any = '';
  totalRecords!: number;
  totalExceptionRecords!: number;
  selectedRecord: FinraException;
  multiLegEventArray: any = [];
  selectedRow: any = [];
  dataLoading!: boolean;
  screenLoading!: boolean;
  dataLoadingSymbolsAndCodes!: boolean;
  recordFrom!: number;
  recordTo!: number;
  symbols!: string[];
  codes!: string[];
  userList: any = [];
  latestReportDate: string;
  isFilterLabelReset: any;
  SYMBOL = 'Symbol';
  CODE = 'Code';
  REPORTDATE = 'Date';
  urlParamLatestReportDate: string;
  urlParamCode: string;
  isMultiEdit!: boolean;
  fieldDictionaryList: FieldDictionary[] = [];
  finraExceptionType!: string;
  rowDataforDialog: any;
  rowIndexForDialog!: number;
  actionType!: string;
  firmROEIDList: Array<any> = [];
  correctCodeLength: number = 0;
  isExportToJSON: boolean = false;
  isDisplayCommentDialog: boolean = false;
  isAuditTrail: boolean = false;
  subscription!: Subscription;
  public viewMultiLegEvent: boolean = false;
  massCorrectionFields: any[] = [];
  eventList: any[] = [];
  originalEvent!: string[];
  selectedEventType:any;
  rowsPerPageOptions: any = [];
  isNewROEEntry: boolean = false;
  urlParamDays: string;
  public selectedID:any;
  public selectedReportDate:any;
  public existingEventType:any;
  selectedGroupName:any;
  errorROEID:any;
  CATReporterIMID:any;
  Create_Parent_Exception_Code:any = '3501';
  public pageName:any;
  groupName:any;
  public displayNewROEDialog:boolean=false;
  resetLabel: any;
  addCAISFailureCode=['3701', '3703', '3701', '3703', '3709'];
  ViewCAISFailureCode=['3702', '3704', '3706', '3708', '3710']
   displaySideBar:any=false;
  viewFDID:any=false;
  selectedFDIDDetails:any;
  isEnabledcaisFDIDService:boolean=false;
  firstTimeCheckTabIndex:boolean=true;

  constructor(
    private activatedRoute: ActivatedRoute,
    public finraExceptionService: FinraExceptionService,
    public gridService: GridService,
    public userService: UserService,
    private emitterService: EmitterService,
    private messageService: MessageService,
    public constantService: ConstantService,
    public confirmationService: ConfirmationService,
    public eventTreeService:EventTreeService,
    public dataService: DataService,
    private router: Router,
    public commonColService:GridCommonService
  ) {
    // As json is required for filter panel - keeping it same as cat exception. 
    // TODO need to have common JSON - main change in 3 places reportDate / tradeID / quoteID
    this.cols = listCols["finra-exception-grid-columns"];
    this.quickFilterArray = listCols["finra-exception-quick-search-fields"]; // Initialize Quick-Search Filter Fields
    this.selectedRecord = new FinraException(); // required for view
    // lastReportDate coming from resolver
    this.urlParamLatestReportDate = this.activatedRoute.snapshot.paramMap.get('Date') ?? '';
    this.urlParamCode = this.activatedRoute.snapshot.paramMap.get('Code') ?? '';
    this.urlParamDays = this.activatedRoute.snapshot.paramMap.get('Days') ?? '';
    let urlEncodedFilterParams: any = this.dataService.getViewerEncodedURLParameters(); // Decode URL Params passed from CAT Recon Monthly Summary | Firmwide CAT Summary from CAT Screen
    /*** Get Last CAT Execution date*/
    this.latestReportDate = this.userService.FinraCATLastExceptionReportDate;
    this.finraExceptionService.lastExecutionCATDates = [];
    let defaultParamValues: any = {};
    if(Object.keys(urlEncodedFilterParams).length > 0) {
      this.selectedTabIndex = 1; // Set Tab Index Number for Finra Exception Detail Tab
      this.finraExceptionService.lastExecutionCATDates[0] = new Date(urlEncodedFilterParams["reportDate"][0].toLocaleString('en-US', { timeZone: 'UTC' }));
      this.finraExceptionService.lastExecutionCATDates[1] = new Date(urlEncodedFilterParams["reportDate"][1].toLocaleString('en-US', { timeZone: 'UTC' }));
      defaultParamValues["modifiedFlag"] = urlEncodedFilterParams["modifiedFlag"];
      defaultParamValues["failureCode"] = urlEncodedFilterParams["failureCode"];
      defaultParamValues["failureCodeFilterBy"] = urlEncodedFilterParams["failureCodeFilterBy"];
      defaultParamValues["actualValue"] = urlEncodedFilterParams["actualValue"];
      defaultParamValues["status"] = urlEncodedFilterParams["status"];
    } else {
      this.finraExceptionService.lastExecutionCATDates[0] = this.latestReportDate;
      this.finraExceptionService.lastExecutionCATDates[1] = this.latestReportDate;
    }
    defaultParamValues["catFieldTypes"] = this.finraExceptionService.catFieldTypes;
    this.finraExceptionService.catFieldTypes = this.userService.getDropDownList('type');
    this.finraExceptionService.defaultFilters = this.finraExceptionService.getDefaultFilters(
      this.finraExceptionService.lastExecutionCATDates,
      defaultParamValues
    );
    this.ApplicationName = this.constantService.getApplicationName();
    this.multiLegEventArray = this.gridService.getMultiLegEventTypes();
    let originalEvent = this.constantService.CONVERT_EVENT_LIST.replace(/ /g, '').split(',');
    for(let i=0;i<originalEvent.length;i++) {      
       this.eventList.push({label:originalEvent[i],value:originalEvent[i]});
    } 

    for (let i = 0; i < this.finraExceptionService.defaultFilters.length; i++) {
      if (this.finraExceptionService.defaultFilters[i].label.toLocaleLowerCase() == 'type') {
        this.finraExceptionService.defaultFilters[i].dropdownvalue = this.finraExceptionService.catFieldTypes;
       let eventTypes=[];
        for(let j=0; j < this.finraExceptionService.defaultFilters[i].dropdownvalue.length; j++){
          eventTypes.push(this.finraExceptionService.defaultFilters[i].dropdownvalue[j].label);
        }
        this.finraExceptionService.defaultFilters[i].values = eventTypes;
      }
    }

    // Inititalize Default Main Screen Filter Field Values
    this.filterFieldDefaultValues = { modifiedFlag: this.finraExceptionService.modifiedFlagList, type: this.finraExceptionService.catFieldTypes.map((elem: any) => elem.value) };
  }

  ngOnInit() {
    this.finraExceptionService.pageSize = this.constantService.DEFAULT_ROWSIZE;
    this.finraExceptionService.pageNumber = this.constantService.DEFAULT_PAGENUMBER;
    this.finraExceptionService.sortField = 'symbol,firmROEID';
    this.finraExceptionService.sortOrder = 1;
    this.totalExceptionRecords = this.constantService.DEFAULT_ROWSIZE;
    /* Dynamically Add Rows Per Page for Finra Exception Screen screen only */
    this.rowsPerPageOptions = [...this.constantService.DEFAULT_ROWSPERPAGEOPTION];
   
    if(this.urlParamCode && this.urlParamCode != "0"){
      this.updateDefaultFilterValues(this.CODE, this.urlParamCode);
    }
    if (this.urlParamLatestReportDate) {
      if (this.urlParamLatestReportDate == 'Null' || this.urlParamLatestReportDate == 'NULL') {
        const today = new Date();
        // Get 1 days back date from current date
        const oneDaysAgo = new Date(today.setDate(today.getDate() - 1));
        this.updateDefaultFilterValues(this.REPORTDATE, [oneDaysAgo, new Date()]);
      } else {
        this.updateDefaultFilterValues(this.REPORTDATE, [this.urlParamLatestReportDate, this.urlParamLatestReportDate]);
      }
      this.updateDefaultFilterValues("Rsms Status", ['N']);
      this.getFinraExceptions(false, false, true);
      this.emitterService.ReloadQuickFilterPanelEvent.emit('true');
    } else {
      this.getFinraExceptions(true, true, false);
    }
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe({
      next: (value:any) => {
      if (value) {
        this.getFinraExceptions(true, true, false);
      }
    }});
    this.isMultiEdit = false;
    /* Retrieve List of Users */
    this.gridService.getUserList()
    .subscribe({
      next: (data:any) => {
      this.userList = data.Data;
      this.userList.unshift({label: 'Select User', value: ''});
    }});
    this.prepareMassCorrectionFields(); // Prepare Mass Correction Fields
    this.originalEvent = this.constantService.CONVERT_EVENT_LIST.replace(/ /g, '').split(',');
    this.isEnabledcaisFDIDService =this.userService.isEnabledcaisFDIDService;
    this.commonColService.init(this.cols, 'Finra-Exception');
  }
  ngAfterViewChecked(){
    this.isEnabledcaisFDIDService =this.userService.isEnabledcaisFDIDService;
  }

  prepareMassCorrectionFields() {
    // List of Non Mass Updatable Fields
    let NonUpdatableFinraGridColumns = ["reportDate", "catReporterIMID", "groupName", "type", "firmROEID", "actionType", "failureCode", "failureDescription", "fileName", "modifiedFlag", "status", "user", "actualValue", "suggestedValue", "eventTimestamp", "quoteMPID", "actualID_1", "actualKeyDate_1", "actualID_2", "actualKeyDate_2", "createDate", "lastUpdate"];

    // Receive all Finra Exception Grid Columns and exclude Non Updatable Fields from it
    let finraExceptionGridColumns: any = listCols["finra-exception-grid-columns"].filter(finraExcpGridCol => (NonUpdatableFinraGridColumns.indexOf(finraExcpGridCol.db_columnname) === -1));

    // Prepare Mass Updatable Fields List
    let massCorrectionCustomizeFields = [
      {"display": "true", "ui_columnname": "Order Key Date", "db_columnname": "orderKeyDate", "datatype": "String", "mappingkey": "orderKeyDate", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": "", "fieldtype": "maskfield", "mask": "99999999T999999", "placeholder": "yyyymmddThhmmss", "regularexpressions": ["^\\d{8}T\\d{6}$"]},
      {"display": "true", "ui_columnname": "Destination Type", "db_columnname": "destinationType", "datatype": "String", "mappingkey": "destinationType", "dropdown": "YES", "isdefault": "false", "disabled": "false", "value": "", "dropdowntype": "singleselect", "dropdownvalue": ""},
      {"display": "true", "ui_columnname": "Status", "db_columnname": "actionType", "datatype": "String", "mappingkey": "actionType", "dropdown": "YES", "isdefault": "false", "disabled": "false", "value": "", "dropdowntype": "singleselect", "dropdownvalue": [{label: 'New', value: 'NEW'}, {label: 'Confirm', value: 'CONFIRM'}, {label: 'Corrected', value: 'CORRECTED'}, {label: 'Generated', value: 'GENERATED'}, {label: 'Delete', value: 'DELETE'}], "isMandatoryComment": true},
      {"display": "true", "ui_columnname": "Option ID", "db_columnname": "optionID", "datatype": "String", "mappingkey": "optionID", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
      {"display": "true", "ui_columnname": "Trading Session", "db_columnname": "tradingSession", "datatype": "String", "mappingkey": "tradingSession", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
      {"display": "true", "ui_columnname": "Account Holder Type", "db_columnname": "accountHolderType", "datatype": "String", "mappingkey": "accountHolderType", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
      {"display": "true", "ui_columnname": "Affiliate Flag", "db_columnname": "affiliateFlag", "datatype": "Boolean", "mappingkey": "affiliateFlag", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdowntype": "", "dropdownvalue": ""}
    ];

    // Prepare Final Mass Correction Eligible Field List from Mass Updatable Field List & Finra Exception Grid Columns excluding Non Updatable Fields
    this.massCorrectionFields = massCorrectionCustomizeFields.concat(finraExceptionGridColumns.filter(
        (finraexceptiongridcol: any) => !massCorrectionCustomizeFields.some(masscorrectionfield => masscorrectionfield.db_columnname === finraexceptiongridcol.db_columnname))
    );

  }

  loadRecordsLazy(event: any | LazyLoadEvent) {
     if (this.commonColService.isCtrlPressed|| this.commonColService.isDragging || this.commonColService.selectedFields.length > 1) {
        this.dt.multiSortMeta =[];
        this.dt.sortField = '';
        this.dt.sortOrder = 0;
        return;
  }
    this.finraExceptionService.pageSize = event.rows ?? 0;
    if (event.first !== undefined && event.rows !== undefined) {
    this.finraExceptionService.pageNumber = event.first / event.rows + 1;
    } else {
      this.finraExceptionService.pageNumber = 0;
    }
    this.finraExceptionService.sortField = event.sortField ?? "";
    this.finraExceptionService.sortOrder = event.sortOrder ?? 0;

    this.getFinraExceptions(false, false, true);
  }

  getFinraExceptions(screenLoading: boolean, dataLoadingSymbolsAndCodes: boolean, dataLoading: boolean) {
    this.selectedRow = [];
    this.correctCodeLength = 0;
    this.dataLoading = dataLoading;
    this.screenLoading = screenLoading;
    this.dataLoadingSymbolsAndCodes = dataLoadingSymbolsAndCodes;
    this.finraExceptionService
      .getFinraExceptions(
        this.finraExceptionService.defaultFilters,
        this.finraExceptionService.pageSize,
        this.finraExceptionService.pageNumber,
        this.finraExceptionService.sortField,
        this.finraExceptionService.sortOrder
      )
      .subscribe({
      next: (response:any) => {
          this.finraExceptionService.finraExceptions = response.MATERIAL_LIST ?? [];
          if(this.finraExceptionService.finraExceptions.length > 0) {
            for(let i=0;i<this.finraExceptionService.finraExceptions.length;i++) {
              if(this.finraExceptionService.finraExceptions[i]['type'].startsWith("ML") === true) {
               try{
                let originalJSON = JSON.parse(this.finraExceptionService.finraExceptions[i]['originalJSON']);
                (this.finraExceptionService.finraExceptions[i] as any)['optionalSymbol'] = ((this.finraExceptionService.finraExceptions[i] as any)['underlying'] ? (this.finraExceptionService.finraExceptions[i] as any)['underlying'] : ((originalJSON['legDetails'] && originalJSON['legDetails'].length > 0) ? (originalJSON['legDetails'][0]['symbol'] ? originalJSON['legDetails'][0]['symbol'] : (originalJSON['legDetails'][0]['optionID'] ? originalJSON['legDetails'][0]['optionID'].split(' ')[0] : '')) : ''));
               }catch(e){}
              }
            }
          }
          this.totalRecords = response.TOTAL_RECORDS ?? 0;
          this.totalExceptionRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          if(this.firstTimeCheckTabIndex){
          this.selectedTabIndex = (this.totalRecords > 50 ? 0 : 1); // Set Tab Index Number for Finra Exception Summary | Detail Tab
          this.firstTimeCheckTabIndex = false;
        }
          this.recordFrom = (response.TOTAL_RECORDS > 0 ? ((this.finraExceptionService.pageNumber - 1) * this.finraExceptionService.pageSize + 1) : 0);
          this.recordTo = this.finraExceptionService.pageNumber * this.finraExceptionService.pageSize;
          // adjust recordTo incase it is greater than totalRecords
          if (this.recordTo > this.totalRecords) {
            this.recordTo = this.totalRecords;
          }
          this.symbols = response.SYMBOLS;
          this.codes = response.CODES;
          this.dataLoading = false;
          this.screenLoading = false;
          this.dataLoadingSymbolsAndCodes = false;
        },
        error: (err: HttpErrorResponse) => {
          this.totalRecords = 0;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          this.dataLoading = false;
          this.screenLoading = false;
          this.dataLoadingSymbolsAndCodes = false;
          this.messageService.clear();
          this.messageService.add({
            severity: this.constantService.MESSAGE_SEVERITY_ERROR,
            summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Error in getting list'
          });
        }
      });
  }

  updateDefaultArray($event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol/Exception-Code Filter
    this.finraExceptionService.defaultFilters = $event;
    this.finraExceptionService.pageNumber = this.constantService.DEFAULT_PAGENUMBER;
    this.dt.first = 1; // Reset Selected Page to Initial Page
    this.getFinraExceptions(false, false, true);
  }

  clearQuickSearch($event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol/Exception-Code Filter
    this.finraExceptionService.defaultFilters = $event;
    this.finraExceptionService.pageNumber = this.constantService.DEFAULT_PAGENUMBER;
    this.dt.first = 1; // Reset Selected Page to Initial Page
    this.getFinraExceptions(false, false, true);
  }

  onView(selectedRecord: FinraException) {
    this.correctCodeLength = 0;
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (selectedRecord)
    }
    this.selectedRecord = selectedRecord;
    this.getFiledDictionaryForEditView('view');
  }

  onEdit(selectedRecord: FinraException) {
    this.correctCodeLength = 0;
    this.firmROEIDList = [];
    this.isMultiEdit = false;
    this.selectedRow = this.dataService.checkRowExistanceInList(selectedRecord, this.selectedRow, 'firmROEID'); // Check Row Object Existance in selected Row Object List
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (selectedRecord);
      this.isMultiEdit = false;
      this.selectedRecord = selectedRecord;
      this.getFiledDictionaryForEditView('edit');
    } else {
      this.validateMultiEdit(selectedRecord);
    }
  }

  validateMultiEdit(selectedRecord: FinraException) {
    this.selectedRow.forEach((row: { type: any; failureCode: any; }) => {
      if (this.selectedRow[0].type === row.type && this.selectedRow[0].failureCode === row.failureCode) {
        this.correctCodeLength = this.correctCodeLength + 1
      } else {
        this.correctCodeLength = this.correctCodeLength - 1
      }
    });

    if (this.selectedRow.length === this.correctCodeLength) {
      this.isMultiEdit = true;
      this.selectedRow.forEach((element: { id: number, firmROEID: string; }) => {
        this.firmROEIDList.push({"id": element.id, "firmROEId": element.firmROEID})
      });
      this.selectedRecord = selectedRecord;
      this.getFiledDictionaryForEditView('edit');
    } else {
      // this.Edit = false
      this.correctCodeLength = 0;
      this.isMultiEdit = false;
      this.confirmationService.confirm({
        message: 'Selected records must have same Group, Event type and Exception code',
        icon: 'pi pi-exclamation-triangle', 
        rejectVisible: false,
        header: 'Confirmation',
        acceptLabel: 'Ok',
        acceptIcon:'pi pi-check',
        acceptButtonStyleClass:"confirm-dialog-button",

        accept: () => {

        }
      });

    }
  }

  getFiledDictionaryForEditView(action: string) {
    this.dataLoading = true;
    this.finraExceptionService
      .getFiledDictionaryForEditView(this.selectedRecord.id)
      .subscribe({
          next: (response:any) => {
          this.dataLoading = false;
          if (action === 'edit') {
            this.finraExceptionService.showEdit = true;
          } else if (action === 'view') {
            this.finraExceptionService.showView = true;
          }

          this.fieldDictionaryList = response.LIST_FIELDDICTIONARY;
          this.finraExceptionType = response.FINRAEXCEPTION_TYPE
          // get the model value separately for timeinforce
        },
        error: (err: HttpErrorResponse) => {
          this.dataLoading = false;
          this.fieldDictionaryList = [];
        }
      });
  }

  onDelete(selectedRecord: FinraException) {
    this.selectedRow = this.dataService.checkRowExistanceInList(selectedRecord, this.selectedRow, 'firmROEID'); // Check Row Object Existance in selected Row Object List
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (selectedRecord)
      this.singleDelete(selectedRecord);
    } else {
      this.multiDelete();
    }
  }

  singleDelete(selectedRecord: FinraException) {
    this.confirmationService.confirm({
      message: this.constantService.DELETE_CONFIRM_MESSAGE,
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        this.dataLoading = true;
        this.finraExceptionService
          .deleteFinraExceptions(selectedRecord.id)
          .subscribe({
            next: (data:any) => {
              this.dataLoading = false;
              this.getFinraExceptions(false, false, true);
              if (data === true) {
                this.messageService.add({
                  severity: this.constantService.MESSAGE_SEVERITY_SUCCESS,
                  summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: this.constantService.MESSAGE_DELETE_SUCCESS_MSG
                });
              } else {
                this.messageService.add({
                  severity: this.constantService.MESSAGE_SEVERITY_ERROR,
                  summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: this.constantService.MESSAGE_DELETE_ERROR_MSG
                });
              }
            },
            error: (err: HttpErrorResponse) => {
              this.dataLoading = false;
              this.messageService.clear();
              this.messageService.add({
                severity: this.constantService.MESSAGE_SEVERITY_ERROR,
                summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: this.constantService.MESSAGE_DELETE_ERROR_MSG
              });
            }
          });
      },
    });
  }

  multiDelete() {
    this.confirmationService.confirm({
      message: this.constantService.DELETE_CONFIRM_MESSAGE,
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        this.dataLoading = true;
        this.finraExceptionService
          .deleteMultipleFinraExceptions(this.selectedRow)
          .subscribe({
            next: () => {
              this.dataLoading = false;
              this.getFinraExceptions(false, false, true);
              this.messageService.add({
                severity: this.constantService.MESSAGE_SEVERITY_SUCCESS,
                summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: this.constantService.MESSAGE_DELETE_SUCCESS_MSG
              });
            },
            error: (err: HttpErrorResponse) => {
              this.dataLoading = false;
              this.messageService.clear();
              this.messageService.add({
                severity: this.constantService.MESSAGE_SEVERITY_ERROR,
                summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: this.constantService.MESSAGE_DELETE_ERROR_MSG
              });
            }
        });
      },
    });
  }

  onShowOrderViewer(rowData: any, rowIndex: any) {
    this.emitterService.isOrderViewerOpenCloseEvent.emit(
      {
        display: true,
        rowData: rowData,
        pageName: 'Finra-Exception'
      });
  }

  onRestore(selectedRecord: FinraException) {
    this.selectedRow = this.dataService.checkRowExistanceInList(selectedRecord, this.selectedRow, 'firmROEID'); // Check Row Object Existance in selected Row Object List
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (selectedRecord)
      this.singleRestore(selectedRecord);
    }
    this.restoreMultiple();
  }

  singleRestore(selectedRecord: FinraException) {
    this.confirmationService.confirm({
      message: this.constantService.RESTORE_CONFIRM_MESSAGE,
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        this.dataLoading = true;
        this.finraExceptionService
          .restoreFinraExceptions(selectedRecord.id)
          .subscribe({
            next: () => {
              this.getFinraExceptions(false, false, true);
              this.messageService.clear();
              this.dataLoading = false;
              this.messageService.add({
                severity: this.constantService.MESSAGE_SEVERITY_SUCCESS,
                summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: this.constantService.MESSAGE_RESTORE_SUCCESS_MSG
              });
            },
            error: (err: HttpErrorResponse) => {
              this.messageService.clear();
              this.dataLoading = false;
              this.messageService.add({
                severity: this.constantService.MESSAGE_SEVERITY_ERROR,
                summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: this.constantService.MESSAGE_RESTORE_ERROR_MSG
              });
            }
          });
      },
    });
  }

  restoreMultiple() {
    this.confirmationService.confirm({
      message: this.constantService.RESTORE_CONFIRM_MESSAGE,
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        this.dataLoading = true;
        this.finraExceptionService
          .restoreMultipleFinraExceptions(this.selectedRow)
          .subscribe({
            next: () => {
              this.dataLoading = false;
              this.getFinraExceptions(false, false, true);
              this.messageService.clear();
              this.messageService.add({
                severity: this.constantService.MESSAGE_SEVERITY_SUCCESS,
                summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: this.constantService.MESSAGE_RESTORE_SUCCESS_MSG
              });
            },
            error: (err: HttpErrorResponse) => {
              this.messageService.clear();
              this.dataLoading = false;
              this.messageService.add({
                severity: this.constantService.MESSAGE_SEVERITY_ERROR,
                summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: this.constantService.MESSAGE_RESTORE_ERROR_MSG
              });
            }
          });
      },
    });
  }

  onApplySuggest(selectedRecord: FinraException) {
    this.selectedRow = this.dataService.checkRowExistanceInList(selectedRecord, this.selectedRow, 'firmROEID'); // Check Row Object Existance in selected Row Object List
    /* If Click on Apply Suggest for Single Row then add it in selectedRow List */
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (selectedRecord)
    }

    let optedRows = [];
    if (this.selectedRow.length > 0) {
      for(let selectedRowIndex in this.selectedRow) {
        if(this.selectedRow[selectedRowIndex].isEligibleToApplySuggestVal && this.selectedRow[selectedRowIndex].failureCode === selectedRecord.failureCode) {
          optedRows.push(this.selectedRow[selectedRowIndex]);
        } else {
          this.messageService.add({
            severity: this.constantService.MESSAGE_SEVERITY_WARN,
            summary: this.constantService.MESSAGE_SUMMARY_WARN, detail: "Records should belong to the same Exception Code"
          });
        }
      }
    }
    this.selectedRow = [...optedRows];
    this.applySuggest();
  }

  applySuggest() {
    this.confirmationService.confirm({
      message: this.constantService.APPLY_SUGGEST_CONFIRM_MESSAGE,
      header: 'Confirmation',
      acceptLabel: 'Yes',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        this.dataLoading = true;
        this.finraExceptionService
          .applySuggestedValuesFinraExceptions(this.selectedRow)
          .subscribe({
            next: (result: any) => {
              this.dataLoading = false;
              this.messageService.clear();
              if(result.status) {
                this.messageService.add({
                  severity: this.constantService.MESSAGE_SEVERITY_SUCCESS,
                  summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: this.constantService.MESSAGE_APPLY_SUGGEST_SUCCESS_MSG
                });
                this.getFinraExceptions(false, false, true); // Reload Screen after 
                this.userService.logUserActivity('Apply Suggested Action for Finra Exceptions', null, {
                  'Text1': 'Succeded Apply Suggested Action for ' + (this.selectedRow.length > 0 ? this.selectedRow.length : 0) + ' Finra Exceptions',
                  'Text2': 'User Filter Parameters: ' + JSON.stringify(this.selectedRow)
                });
              } else {
                this.messageService.add({
                  severity: this.constantService.MESSAGE_SEVERITY_ERROR,
                  summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: this.constantService.MESSAGE_APPLY_SUGGEST_ERROR_MSG
                });
                this.userService.logUserActivity('Apply Suggested Action for Finra Exceptions', null, {
                  'Text1': 'Failed Apply Suggested Action for ' + (this.selectedRow.length > 0 ? this.selectedRow.length : 0) + ' Finra Exceptions',
                  'Text2': 'User Filter Parameters: ' + JSON.stringify(this.selectedRow)
                });
              }
            },
            error: (err: HttpErrorResponse) => {
              this.messageService.clear();
              this.dataLoading = false;
              this.messageService.add({
                severity: this.constantService.MESSAGE_SEVERITY_ERROR,
                summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: this.constantService.MESSAGE_APPLY_SUGGEST_ERROR_MSG
              });
              this.userService.logUserActivity('Apply Suggested Action for Finra Exceptions', null, {
                'Text1': 'Failed Apply Suggested Action for ' + (this.selectedRow.length > 0 ? this.selectedRow.length : 0) + ' Finra Exceptions',
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.selectedRow)
              });
            }
          });
      },
    });
  }

  onFilterEventClearSymbol(event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit(this.SYMBOL);
  }

  onFilterEventClearCode(event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit(this.CODE);
  }

  onFilterApplyFilterEvent(event: any) {
    this.finraExceptionService.defaultFilters = event;
    this.finraExceptionService.pageNumber = 1;
    this.dt.first = 1; // Reset Selected Page to Initial Page
    this.getFinraExceptions(true, true, false);
  }

  onActiveSymbolEvent(event: any) {
    this.updateDefaultFilter(this.SYMBOL, event);
  }

  onActiveCodeEvent(event: any) {
    this.updateDefaultFilter(this.CODE, event);
  }

  updateDefaultFilter(type: string, event: any) {
    for (let i = 0; i < this.finraExceptionService.defaultFilters.length; i++) {
      if (this.finraExceptionService.defaultFilters[i].label.toLocaleLowerCase() === type.toLocaleLowerCase()) {
        this.finraExceptionService.defaultFilters[i].values = event;
        this.finraExceptionService.defaultFilters = [...this.finraExceptionService.defaultFilters];
        this.dataLoadingSymbolsAndCodes = false;
        this.finraExceptionService.pageNumber = 1;
        this.getFinraExceptions(false, false, true);
        this.emitterService.ReloadQuickFilterPanelEvent.emit('true');
      }
    }
  }

  updateDefaultFilterValues(type: string, event: any) {
    for (let i = 0; i < this.finraExceptionService.defaultFilters.length; i++) {
      if (this.finraExceptionService.defaultFilters[i].label.toLocaleLowerCase() === type.toLocaleLowerCase()) {
        this.finraExceptionService.defaultFilters[i].values = event;
      }
    }
  }
  onShowROEEdit(actionType: string, selectedRecord: FinraException, index: number) {
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (selectedRecord)
    }
    this.selectedRecord = selectedRecord;
    this.finraExceptionService.showROEEdit = true;
    this.rowDataforDialog = selectedRecord;
    this.rowIndexForDialog = index;
    this.actionType = actionType;
  }
  closeDialog(value: any) {
    this.finraExceptionService.showROEEdit = false;
  }

  // Check whether Exception Code has been selected by User Or Not
  getAppliedCodeFilter(exceptionCode?: any) {
    let codeDefaultFilter = this.finraExceptionService.defaultFilters.filter((defaultFilter) => defaultFilter.label.toLocaleLowerCase() === this.CODE.toLocaleLowerCase());
    if(exceptionCode) {
      return (codeDefaultFilter && codeDefaultFilter[0].values && codeDefaultFilter[0].values === exceptionCode) ? true : false;
    } else {
      return (codeDefaultFilter && codeDefaultFilter[0].values) ? true : false;
    }
  }

  onShowMassCorrectionScreen() {

    if(this.getAppliedCodeFilter()) {
      this.userService.showMassCorrection = true;
    } else {
      this.userService.showMassCorrection = false;
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select the Exception Code to proceed with Mass Correction' });
    }
  }

  updateMassCorrectedField(event: any) {
    this.userService.showMassCorrection = false;
    this.getFinraExceptions(false, false, true);
  }

  exportToJSON() {
    if(this.userService.enableFileExport()){
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    this.isExportToJSON = true;
    let reportdate = this.userService.getyyyyMMddDateFormate(this.finraExceptionService.defaultFilters[0].values[0]);
    this.finraExceptionService
      .exportToJSON(reportdate)
      .subscribe({
        next: (response:any) => {
        const blob = new Blob([response], { type: 'application/octet-stream' });
        let filename = this.userService.getActiveMPID() + "_" + reportdate + ".json";
        saveAs(blob, filename);
        this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Downloaded Successfully' });
        this.isExportToJSON = false;
        this.userService.logUserActivity('Export Exceptions in JSON', null, {
          'Text1': 'File Downloaded Successfully | ' + (this.totalRecords > 0 ? this.totalRecords : 0) + ' records downloaded with file name: ' + filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.finraExceptionService.defaultFilters.filter((filterParam) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'warn', summary: 'File', detail: 'File Download Failed.' });
          this.isExportToJSON = false;
          this.userService.logUserActivity('Export Exceptions in JSON', null, {
            'Text1': 'File Download Failed',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.finraExceptionService.defaultFilters.filter((filterParam) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }});
      }

  }
  exportToCSV(event: any) {
    if(this.userService.enableFileExport()){
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    let pageSize = event.isExportMaxRows ? this.constantService.NUMBER_MAX_EXPORT_ROWS :  this.finraExceptionService.pageSize
    let pageNumber =  event.isExportMaxRows ? 1 : this.finraExceptionService.pageNumber
     this.finraExceptionService
      .getFinraExceptions(
        this.finraExceptionService.defaultFilters,
        pageSize,
        pageNumber,
        this.finraExceptionService.sortField,
        this.finraExceptionService.sortOrder
      )
      .subscribe({
        next: (response:any) => {
          let data  = response.MATERIAL_LIST ?? [];
          if(data.length > 0) {
            const options: any = {
              fieldSeparator: ',',
              quoteStrings: '"',
              decimalSeparator: '.',
              showLabels: true,
              showTitle: true,
              title: 'RSMS_FINRA_Exception_' + this.userService.getyyyyMMddDateFormate(new Date()),
              useTextFile: false,
              useBom: true,
              useKeysAsHeaders: true,
              // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
              filename: this.userService.getActiveMPID() +'_RSMS_FINRA_Exception_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
            };
            const csvData = this.constantService.getExportData(data, event.gridColumn);
            const csv = generateCsv(options)(csvData);
            const blob = asBlob(options)(csv);
            saveAs(blob,options.filename);
            this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
            this.userService.logUserActivity('Export CSV', null, {
              'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
              'Text2': 'User Filter Parameters: ' + JSON.stringify(this.finraExceptionService.defaultFilters.filter((filterParam) => (filterParam.values != '' || filterParam.values.length > 0)))
            });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
            this.userService.logUserActivity('Export CSV', null, {
              'Text1': 'No data found',
              'Text2': 'User Filter Parameters: ' + JSON.stringify(this.finraExceptionService.defaultFilters.filter((filterParam) => (filterParam.values != '' || filterParam.values.length > 0)))
            });
          }
          this.emitterService.exportToCSVData.emit(true);
        }, error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'Error while Exporting',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.finraExceptionService.defaultFilters.filter((filterParam) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }
      });
    }
  }

  onTree(rowData: any) {
    this.eventTreeService.isDialogOpen=true;
      this.selectedRow = [];
      this.selectedRow[0] = rowData
  }

  onAuditTrail(rowData: any) {
    this.isAuditTrail=true;
      this.selectedRow = [];
      this.selectedRow[0] = rowData
  }

  counterpartyPartyReport() {
    this.finraExceptionService.showCounterpartyReport = true;
  }

  getTooltipContent(row: any) {
    return `<strong style="color: #83d0f2;">Status:&nbsp;</strong><span style="color: #e8f0fe;">${row.caseStatus}</span>
            <strong style="color: #83d0f2;">Owner:&nbsp;</strong><span style="color: #e8f0fe;">${row.caseOwner}</span>
            <strong style="color: #83d0f2;">Comment:&nbsp;</strong><span style="color: #e8f0fe;">${row.caseComments}</span>`;
  }

  addComment(rowData: any) {
    let searchExceptionItem = (this.selectedRow.length > 0) ? this.selectedRow.filter((selectedRowDetail: { id: any; }) => selectedRowDetail.id === rowData.id) : [];

    if ((this.selectedRow.length === 0) || (this.selectedRow.length > 0 && searchExceptionItem.length === 0)) {
      this.selectedRow = [];
      this.selectedRow.push(rowData);
    }
    this.isDisplayCommentDialog = true;
  }

  updateClientDataStaus(event: any) {
        this.dataLoading = true;
        if(event.selectedRow.length) {
          let selectedUserName = this.userList.filter((user: { value: any; }) => user.value===event.selectedUser);
          for(let i=0; i<event.selectedRow.length; i++) {
             this.finraExceptionService.updateClientDataExceptionStatus({
              exceptionId: event.selectedRow[i].id,
              status: event.selectedStatus,
              owner: selectedUserName[0].label.toUpperCase(),
              comment: event.commentStatement,
              updatedBy: this.userService.getUserName()
            }).subscribe({
              next: (result:any) => {
              if((i === event.selectedRow.length - 1)) {
                this.getFinraExceptions(false, false, true);
                this.dataLoading = true;
              }
            }});
          }
          this.isDisplayCommentDialog = false;
          this.selectedRow = [];

          this.messageService.clear();
          this.messageService.add({ severity: 'success', summary: 'success', detail: 'Comments added successfully!' });
        }
  }

  getNumberofLegs(row: any) {
    if(row['originalJSON']) {
      try{
      let rawJson = JSON.parse(row['originalJSON']);
      return (rawJson['numberOfLegs'] > 0 ? rawJson['numberOfLegs'] : 0);
      }catch(Error){
        console.log("invalid JSON");
        return 1;
      }   
    }

  }

  onClickMultiLegEvent(index: any, rowData: FinraException) {
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (rowData);
    }
    this.selectedRecord = rowData;
    this.rowDataforDialog = rowData;
    this.rowIndexForDialog = index;
    this.viewMultiLegEvent = true;
  }

  closeMultiLegEvent(event: any) {
    this.viewMultiLegEvent = false;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // Open Create Parent Dialogbox/SubComponent
  onOptingCreateParentEventType() {
    // Check Whether USer has selected Exception Code - 3501 Or Not 
    if(this.getAppliedCodeFilter(this.Create_Parent_Exception_Code)) {
      this.finraExceptionService.showCreateParentScreen = true;
    } else {
      this.finraExceptionService.showCreateParentScreen = false;
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select Exception Code 3501 to create Parent Exception' });
    }
  }

  onEventTypeChange(e:any) {   
    if(e.value != null && e.value != undefined){     
      if (this.selectedRow.length == 1) {
        this.selectedID = this.selectedID;
        this.pageName='Finra-Exception';        
        } else{
          this.selectedID = null;
        this.pageName='Finra-Exception';       
        this.errorROEID=null;
        }
        this.displayNewROEDialog = true;
        this.displayDropdownTypeBySelectedType(this.selectedRow[0]);
    } else{
      this.displayNewROEDialog = false;
    }   
  }

  displayDropdownTypeBySelectedType(selectedRecord: FinraException) {
    if(selectedRecord == undefined){
      return;
    }
    let selectedRow1: any = this.dataService.checkRowExistanceInList(selectedRecord, this.selectedRow, 'firmROEID'); // Check Row Object Existance in selected Row Object List
    selectedRow1 = selectedRow1[0];
    if (selectedRow1 == undefined) {
      return;
    }
    this.eventList = [];
    if (this.selectedRow.length > 1) {
      for (let i = 0; i < this.originalEvent.length; i++) {
        this.eventList.push({ label: this.originalEvent[i], value: this.originalEvent[i] });
      }
      return;
    }
    this.selectedID = selectedRow1.firmROEID;
    this.selectedReportDate = selectedRow1.reportDate;
    this.existingEventType = selectedRow1.type;
    this.selectedGroupName = selectedRow1.groupName;
    this.errorROEID = selectedRow1.errorROEID;
    this.CATReporterIMID= selectedRow1.catReporterIMID;
    this.eventList = this.constantService.populateEventList(this.existingEventType);
  }

  // Call for Post Parent Creation Action
  postCreateParentAction(event : any) {
    this.finraExceptionService.showCreateParentScreen = false;
    this.getFinraExceptions(false, false, true);
  }

  closeDropdown(e:any){
    this.selectedEventType = null;
    this.displayNewROEDialog = false;
    this.selectedRow = [];
    this.rowDataforDialog = [];
  }
   addCaisDetails(rowData: any) {
    this.displaySideBar = true;
    this.viewFDID = true;
    this.selectedFDIDDetails = rowData;
  }
  onClickCancelFDID() {
    this.viewFDID = false;
    this.displaySideBar = false;
    this.selectedFDIDDetails = {};
  }

  checkErrorcode(failureCode: any, suggestedValue: any) {
    if (this.addCAISFailureCode.includes(failureCode)) {
      return 'Add CAIS in FDID';
    }
    if (this.ViewCAISFailureCode.includes(failureCode)) {
      return 'View CAIS in FDID';
    }
    return suggestedValue;
  }
   openDetails(rowData: any) {
    if (this.addCAISFailureCode.includes(rowData['failureCode'])) {
      if (rowData.actualValue && rowData.actualValue != "" && rowData.actualValue.trim() != "") {
        this.addCaisDetails(rowData);
      }
      else {
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Actual value for FDID is not present' });
      }
    }
    if (this.ViewCAISFailureCode.includes(rowData['failureCode'])) {
      if (rowData.firmDesignatedID && rowData.firmDesignatedID != "" && rowData.firmDesignatedID.trim() != "") {
        this.viewCaisDetails(rowData);
      }
      else {
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Actual value for FDID is not present' });
      }
    }
  }
  viewCaisDetails(rowData: any) {
    let urlParams = {
      "firmDesignatedID": rowData.firmDesignatedID
    };

    /* Catch User Action Log */
      this.userService.logUserActivity("Reviewed CAIS-FDID Records", null, {
        'Text1': this.userService.userFirstName + ' reviewed CAIS-FDID records from Finra-Exceptions',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(urlParams)
      });

    this.router.navigate([]).then(result => { window.open('#/Rsms/pages/CAIS/FDID?mode=View&FDIDData=' + btoa(JSON.stringify(urlParams))) });
  }

}